import React, {useEffect, useState} from "react";
import {ReactSpreadsheetImport} from "react-spreadsheet-import";
import {Button} from "react-bootstrap";
import {Result} from "react-spreadsheet-import/types/types";
import {EAIClient} from "Services/EAIClient";
import PageTitle from "Components/Common/PageTitle";
import {useInternalContext} from "@/contexts/internal";

export function FormUploadPage() {
    return (
        <>
            <PageTitle pageTitle={"Official Student List Upload"}/>
            <FormUpload/>
        </>
    );
}

export function FormUpload() {
    const client = new EAIClient( );
    const [isOpen, setIsOpen] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [showSuccessMsg, setShowSuccessMsg] = useState(false);
    const {setRenderActionButton} = useInternalContext();

    const [fields] = useState([
        {
            label: "Student ID",
            key: "student id",
            fieldType: {
                type: "input",
            },
            validations: [
                {
                    rule: "required",
                    errorMessage: "Name is required",
                    level: "error",
                },
            ],
        },
        {
            label: "First Name",
            key: "first name",
            fieldType: {
                type: "input",
            },
            validations: [
                {
                    rule: "required",
                    errorMessage: "Name is required",
                    level: "error",
                },
            ],
        },
        {
            label: "Last Name",
            key: "last name",
            fieldType: {
                type: "input",
            },
            validations: [
                {
                    rule: "required",
                    errorMessage: "Name is required",
                    level: "error",
                },
            ],
        },
        {
            label: "Email",
            key: "email",
            fieldType: {
                type: "input",
            },
            validations: [
                {
                    rule: "required",
                    errorMessage: "Name is required",
                    level: "error",
                },
            ],
        },
        {
            label: "Major code",
            key: "major code",
            fieldType: {
                type: "input",
            },
            validations: [
                {
                    rule: "required",
                    errorMessage: "Name is required",
                    level: "error",
                },
            ],
        },
        {
            label: "Class Of",
            key: "class of",
            fieldType: {
                type: "input",
            },
            validations: [
                {
                    rule: "required",
                    errorMessage: "Name is required",
                    level: "error",
                },
            ],
        },{
            label: "campus",
            key: "campus",
            fieldType: {
                type: "input",
            },
        },{
            label: "Cohort Indicator",
            key: "cohort indicator",
            fieldType: {
                type: "input",
            },
        },{
            label: "other names (student alias)",
            key: "other names (student alias)",
            alternateMatches: ["other names (student alias)"],
            fieldType: {
                type: "input",
            },
        },{
            label: "Other Emails",
            key: "other emails",
            fieldType: {
                type: "input",
            },
        },{
            label: "Other Student IDs",
            key: "other student IDs",
            alternateMatches: ["other student IDs"],
            fieldType: {
                type: "input",
            },
        },{
            label: "Anticipated Graduation Date",
            key: "anticipated graduation date",
            alternateMatches: ["anticipated graduation date"],
            fieldType: {
                type: "input",
            },
        },{
            label: "Status",
            key: "status",
            fieldType: {
                type: "input",
            },
        }
    ]);
    const onClose = () => setIsOpen(false);

    const onSubmit = async (data: Result<string>) => {
        setIsLoading(true);
        onClose();
        try {
            await client.createSisStudents(data.validData);
            setShowSuccessMsg(true);
            setTimeout(() => setShowSuccessMsg(false), 5000);
            setIsLoading(false);
        } catch (e) {
            setIsLoading(false);
            console.error(e);
        }
    };

    useEffect(() => {
        setRenderActionButton(null);
    }, []);

    return (
        <>
            <div className="text-center">
                {!isLoading && <Button onClick={() => setIsOpen(true)} disabled={isLoading}>Upload new file</Button>}
                {isLoading && <p>Uploading...</p>}
                {showSuccessMsg && <p>Success! The file was uploaded correctly</p>}
            </div>
            <ReactSpreadsheetImport
                isOpen={isOpen}
                onClose={onClose}
                onSubmit={onSubmit}
                fields={fields}
                translations={{
                    uploadStep: {
                        title: "Official Student List Upload",
                    },
                }}
                isNavigationEnabled={true} />
        </>
    );
}

